module.exports = "/_next/static/images/3943fea3222f8c08c30329d8e1e24c11-card-background-left-lg.jpg.webp";